<template>
    <div class="empty" v-title="'找不到数据'">
        <img src="../assets/imgs/common/none-01.png" />
        <div class="s5">暂无数据</div>
    </div>
</template>

<script>

export default {
    name: 'not_found',
    data() {
        return {

        }
    }, methods: {
        hide() {
            this.show = false
        }
    }
}
</script>
<style lang="scss" scoped>
@import "../assets/scss/px2rem.scss";

.empty {
    height: px2rem(500);
    position: relative;
}

.empty img {
    display: block;
    width: px2rem(100);
    height: px2rem(100);
    margin: 0 auto;
    margin-top: px2rem(300);
}

.empty div {
    text-align: center;
    padding-top: px2rem(10);
}
</style>



// WEBPACK FOOTER //
// NotFound.vue?d7d5e2e2